import { motion } from "framer-motion";
import { BadgeCheck, ShieldCheck, Clock } from "lucide-react";

const SURVEYOR_IMG =
  "https://images.unsplash.com/photo-1628158145409-9e222b56cc0b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80";
const DRONE_IMG =
  "https://images.unsplash.com/photo-1473968512647-3e447244af8f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80";

const POINTS = [
  { icon: BadgeCheck, label: "Equipe Técnica Qualificada" },
  { icon: ShieldCheck, label: "Equipamentos Calibrados" },
  { icon: Clock, label: "Prazos Rigorosos" },
];

export default function About() {
  return (
    <section id="empresa" className="relative py-24 lg:py-32 bg-deep/40">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid gap-14 lg:grid-cols-2 lg:gap-20 items-center">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 0.6 }}
            className="font-mono text-xs uppercase tracking-[0.32em] text-dm-contour"
          >
            A Empresa
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ delay: 0.1, duration: 0.7 }}
            className="mt-4 font-display text-3xl sm:text-4xl lg:text-[2.75rem] font-bold tracking-tight leading-[1.15] text-white"
          >
            Comprometidos com a{" "}
            <span className="text-gradient">exatidão</span> e a ética técnica
            profissional.
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ delay: 0.2, duration: 0.7 }}
            className="mt-6 space-y-5 text-base leading-relaxed text-slate-300"
          >
            <p>
              A DM Levantamentos Topográficos nasceu com o propósito de
              transformar dados técnicos em segurança para investidores e
              construtores.
            </p>
            <p>
              Com anos de experiência no mercado, utilizamos equipamentos de
              última geração — <span className="text-slate-100 font-medium">RTK,
              Estações Totais e Drones</span>.
            </p>
          </motion.div>

          <motion.ul
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ delay: 0.3, duration: 0.7 }}
            className="mt-9 space-y-4"
          >
            {POINTS.map((p) => (
              <li
                key={p.label}
                data-testid="about-checklist-item"
                className="flex items-center gap-4 rounded-xl glass px-5 py-4 transition-colors duration-300 hover:border-dm-glow/35"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-dm-blue/20 border border-dm-glow/25 text-dm-glow">
                  <p.icon size={17} />
                </span>
                <span className="font-medium text-slate-100">{p.label}</span>
              </li>
            ))}
          </motion.ul>
        </div>

        <div className="relative">
          <motion.div
            initial={{ opacity: 0, y: 40, rotate: 1.5 }}
            whileInView={{ opacity: 1, y: 0, rotate: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="relative rounded-2xl overflow-hidden border border-white/10 shadow-[0_24px_70px_rgba(0,10,30,0.65)]"
          >
            <img
              src={SURVEYOR_IMG}
              alt="Profissional operando equipamento topográfico em campo"
              className="h-[420px] lg:h-[520px] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/55 via-transparent to-transparent" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30, rotate: -4 }}
            whileInView={{ opacity: 1, y: 0, rotate: -3 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ delay: 0.25, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="absolute -bottom-10 -left-4 sm:left-8 w-44 sm:w-56 rounded-xl overflow-hidden border border-dm-glow/30 shadow-[0_18px_50px_rgba(0,10,30,0.7)]"
          >
            <img
              src={DRONE_IMG}
              alt="Drone de mapeamento em voo"
              className="h-32 sm:h-40 w-full object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.45, duration: 0.7 }}
            className="absolute -top-5 -right-2 sm:right-6 glass rounded-full px-5 py-2.5 font-mono text-[11px] tracking-[0.22em] text-dm-glow border border-dm-glow/30"
          >
            RTK · ESTAÇÕES TOTAIS · DRONES
          </motion.div>
        </div>
      </div>
    </section>
  );
}
